// extracted by mini-css-extract-plugin
export default {"main":"FormImage_main__rXxX0","label":"FormImage_label__w2W6I","buttonsArea":"FormImage_buttonsArea__7bZzj","fileInput":"FormImage_fileInput__b8xoM"};